/* eslint-disable max-len */
import {
  action,
  observable,
} from 'mobx';
import {
  BackendEntity,
  ListBackendEntity,
  ModelOf,
} from 'utils';
import {
  BaseBackendStore,
} from '../types';
import {
  promocodes,
  promocode,
} from './requests';
import {
  PromocodesDTO,
} from './types';
import {
  BackendStores,
} from '..';

export class PromocodesStore extends BaseBackendStore {
  @observable private _entityList: PromocodesDTO[] = [];

  @action public getAll = async (options: any): Promise<PromocodesDTO[]> => {
    console.log(options);
    const response = await this.connections.backend
      .httpGet(`${promocodes}`);
    return response;
  };

  @observable entityList = new ListBackendEntity(
    this,
    '_entityList',
    this.getAll,
  );

  constructor(
    public parent: BackendStores,
  ) {
    super();
    this.makeObservable();
    this.registerObservableDrivers();
  }

  @observable private _selectedEntity: PromocodesDTO;

  @observable selectedEntity = new BackendEntity(
    this,
    '_selectedEntity',
    this.getOne,
  );

  @action
  public async create(data: PromocodesDTO): Promise<void> {
    try {
      await this.connections.backend.httpPost(promocodes, data);
      return Promise.resolve();
    } catch (error: any) {
      return Promise.reject(error.response.data.message);
    }
  }

  @action
  public async getOne(id: string): Promise<ModelOf<PromocodesDTO>> {
    const response = await this.connections.backend.httpGet(promocode(parseInt(id, 10)));
    this.selectedEntity = response;
    return Promise.resolve(response);
  }

  @action updatePromocode = async (id: number, data: Partial<PromocodesDTO>) => {
    try {
      const response = await this.connections.backend.httpPut(promocode(id), data);
      return Promise.resolve(response);
    } catch (error: any) {
      return Promise.reject(error.response.data.message);
    }
  };

  @action
  public async delete(id: number): Promise<void> {
    const response = await this.connections.backend
      .httpDelete(promocode(id));
    return Promise.resolve(response);
  }
}
